import { atom, selector } from 'recoil';

import { GetParentOrganisationsRequest } from 'api';
import { PaginationInfo } from 'types';

export const manageOrganisationsPageSizeState = atom<number>({
  key: 'manageOrganisationsPageSize',
  default: 10,
});

export const manageOrganisationsPageNumberState = atom<number>({
  key: 'manageOrganisationsPageNumber',
  default: 1,
});

export const manageOrganisationsPaginationState = atom<PaginationInfo | undefined>({
  key: 'manageOrganisationsPagination',
  default: undefined,
});

export const mangeOrganisationsSearchState = atom<string>({
  key: 'mangeOrganisationsSearch',
  default: '',
});

export const mangeOrganisationsOrderByColumnState = atom<string>({
  key: 'mangeOrganisationsOrderByColumn',
  default: '',
});

export const mangeOrganisationsOrderByDescendingState = atom<boolean | undefined>({
  key: 'mangeOrganisationsOrderByDescending',
  default: undefined,
});

export const organisationsRequestState = selector<GetParentOrganisationsRequest>({
  key: 'organisationsRequest',
  get: ({ get }) => {
    const orderByColumn = get(mangeOrganisationsOrderByColumnState);
    const nameOrEmailSearchText = get(mangeOrganisationsSearchState);

    const request: GetParentOrganisationsRequest = {
      pageSize: get(manageOrganisationsPageSizeState),
      pageNumber: get(manageOrganisationsPageNumberState),
      ...(orderByColumn && {
        orderByColumn,
        orderByDescending: get(mangeOrganisationsOrderByDescendingState),
      }),
      ...(nameOrEmailSearchText && { nameOrEmailSearchText }),
    };

    return request;
  },
});
